import React from "react";

const Home = () => {
  return (
    <div>
      
      {/* Slider Area */}
      <section className="slider">
        <div className="hero-slider">
          {/* Single Slider */}
          <div
            className="single-slider"
            style={{ backgroundImage: "url('img/slider.webp')" }}
          >
            <div className="container">
              <div className="row">
                <div className="col-lg-7">
                  <div className="text" id="financial-services-text">
                    <h1>
                      We Provide <span>Financial</span> Services That You Can{" "}
                      <span>Trust!</span>
                    </h1>
                    <p>
                      We work with you to provide a clear financial strategy to
                      go from where you are to where you want to be through
                    </p>
                    <div className="button">
                      <a
                        href="/contact"
                        
                        className="btn"
                      >
                        Get started
                      </a>
                      <a href="/" className="btn primary">
                        Learn More
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Other Sliders */}
          <div
            className="single-slider"
            style={{ backgroundImage: "url('img/slider2.webp')" }}
          >
            <div className="container">
              <div className="row">
                <div className="col-lg-7">
                  <div className="text" id="financial-services-text">
                    <h1>
                      We Provide <span>Financial</span> Services That You Can{" "}
                      <span>Trust!</span>
                    </h1>
                    <p>
                      We work with you to provide a clear financial strategy to
                      go from where you are to where you want to be through
                    </p>
                    <div className="button">
                      <a
                        href="/contact"
                        
                        className="btn"
                      >
                        Get started
                      </a>
                      <a href="/about" className="btn primary">
                        About Us
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            className="single-slider"
            style={{ backgroundImage: "url('img/slider3.webp')" }}
          >
            <div className="container">
              <div className="row">
                <div className="col-lg-7">
                  <div className="text" id="financial-services-text">
                    <h1>
                      We Provide <span>Financial</span> Services That You Can{" "}
                      <span>Trust!</span>
                    </h1>
                    <p>
                      We work with you to provide a clear financial strategy to
                      go from where you are to where you want to be through
                    </p>
                    <div className="button">
                      <a
                        href="/contact"
                        
                        className="btn"
                      >
                        Get started
                      </a>
                      <a href="/contact" className="btn primary">
                        Contact Us
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* End Slider Area */}

      {/* Schedule Area */}
      <section className="schedule">
        <div className="container">
          <div className="schedule-inner">
            <div className="row">
              {/* Single Schedule */}
              <div className="col-lg-4 col-md-6 col-12">
                <div className="single-schedule first">
                  <div className="inner">
                    <div className="icon">
                      <i className="icofont-chart-pie-alt"></i>
                    </div>
                    <div className="single-content">
                      <h4>Tax Free Tools</h4>
                      <p className="mb-4">Watch Your Free Training Below</p>
                      <a href="/services">
                        LEARN MORE<i className="fa fa-long-arrow-right"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>

              {/* Other Schedules */}
              <div className="col-lg-4 col-md-6 col-12">
                <div className="single-schedule middle">
                  <div className="inner">
                    <div className="icon">
                      <i className="icofont-chart-growth"></i>
                    </div>
                    <div className="single-content">
                      <span>Services We Provide</span>
                      <h4>FINANCIAL STRATEGIES</h4>
                      <p>
                        We work with you to provide a clear financial strategy
                        to go from where you are to where you want to be
                        through.
                      </p>
                      <a href="/services">
                        LEARN MORE<i className="fa fa-long-arrow-right"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-lg-4 col-md-12 col-12">
                <div className="single-schedule last">
                  <div className="inner">
                    <div className="icon">
                      <i className="icofont-ui-clock"></i>
                    </div>
                    <div className="single-content">
                      <h4>Opening Hours</h4>
                      <ul className="time-sidual">
                        <li className="day">
                          Monday - Friday <span>7:00-10:00</span>
                        </li>
                        <li className="day">
                          Saturday - Sunday <span>12:00-06:00</span>
                        </li>
                      </ul>
                      <a href="/services">
                        LEARN MORE<i className="fa fa-long-arrow-right"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* End Schedule Area */}

      <section className="Feautes section">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="section-title">
                <h4>Why Choose Us</h4>
                <h2>Quality Service You Can Trust</h2>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-4 col-12">
              {/* Start Single features */}
              <div className="single-features">
                <div className="signle-icon">
                  <i className="icofont icofont-clock-time"></i>
                </div>
                <h3>Reliable Financial Service</h3>
                <p>.</p>
              </div>
              {/* End Single features */}
            </div>
            <div className="col-lg-4 col-12">
              {/* Start Single features */}
              <div className="single-features">
                <div className="signle-icon">
                  <i className="icofont icofont-ui-check"></i>
                </div>
                <h3>Dedicated to your Financial Success</h3>
                <p></p>
              </div>
              {/* End Single features */}
            </div>
            <div className="col-lg-4 col-12">
              {/* Start Single features */}
              <div className="single-features last">
                <div className="signle-icon">
                  <i className="icofont icofont-calendar"></i>
                </div>
                <h3>24/7 Availability</h3>
                <p></p>
              </div>
              {/* End Single features */}
            </div>
          </div>
        </div>
      </section>
      {/*/ End Feautes */}

      {/* Start Fun-facts */}
      <div className="clients overlay">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 col-md-12 col-12">
              <div className="owl-carousel clients-slider"></div>
            </div>
          </div>
        </div>
      </div>
      {/*/ End Fun-facts */}

      {/* Start Why choose */}
      <section className="why-choose section">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="section-title">
                <h2>About Us</h2>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-6 col-12">
              {/* Start Choose Left */}
              <div className="choose-left">
              <h3>Who We Are</h3>
    <p>
      We are dedicated professionals specializing in senior investor affairs, bringing a strong background in Real Estate and HR management. Our mission in financial assistance stems from firsthand experience—understanding the challenges many families face in securing adequate financial resources for retirement after years of hard work and entrepreneurship.
    </p>
    <p>
      Those who seek our guidance gain substantial benefits, including:
    </p>
    <ul>
      <li>Up to a <strong>50% reduction in tax liabilities</strong></li>
      <li>Elimination of taxes on social security income</li>
      <li>Augmentation of fixed monthly income</li>
      <li>Enhanced safeguards for financial well-being</li>
    </ul>
    <p>
      Committed to promoting financial literacy, we actively conduct seminars and webinars both locally and nationally. We serve communities such as <strong>Contra Costa, Silicon Valley, Marin, and Santa Rosa</strong>, while also extending our reach to <strong>Arizona, Washington, Florida, Texas, and South Carolina</strong>.
    </p>
    <p>
      Our mission aligns with the principle of <em>"no family left behind"</em>, reflecting our unwavering dedication to ensuring comprehensive financial well-being for all.
    </p>
                <div className="row">
                  <div className="col-lg-6">
                    <ul className="list">
                      <li>
                        <i className="fa fa-caret-right"></i>FINANCIAL STRATEGIES
                      </li>
                      <li>
                        <i className="fa fa-caret-right"></i>PROPER PROTECTION
                      </li>
                      <li>
                        <i className="fa fa-caret-right"></i>EMERGENCY FUND
                      </li>
                    </ul>
                  </div>
                  <div className="col-lg-6">
                    <ul className="list">
                      <li>
                        <i className="fa fa-caret-right"></i>DEBT MANAGMENT
                      </li>
                      <li>
                        <i className="fa fa-caret-right"></i>BUILD WEALTH
                      </li>
                      <li>
                        <i className="fa fa-caret-right"></i>PRESERVE WEALTH
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              {/* End Choose Left */}
            </div>
            <div className="col-lg-6 col-md-12">
              <div className="appointment-image1">
                <img src="img/logo2.jpg" alt="#" />
              </div>
            </div>
          </div>
        </div>
      </section>
      {/*/ End Why choose */}

      {/* Start Call to action */}
      <section className="call-action overlay" data-stellar-background-ratio="0.5">
        <div className="container">
          <div className="row"></div>
        </div>
      </section>
      {/*/ End Call to action */}
      <div className="clients overlay">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 col-md-12 col-12">
              <div className="owl-carousel clients-slider"></div>
            </div>
          </div>
        </div>
      </div>

      <section className="services section">
  <div className="container">
    <div className="row">
      <div className="col-lg-12">
        <div className="section-title">
          <h2>SERVICES WE PROVIDE</h2>
          <p>
            We work with you to provide a clear financial strategy to go from
            where you are to where you want to be through
          </p>
        </div>
      </div>
    </div>
    <div className="row">
      <div className="col-lg-4 col-md-6 col-12">
        {/* Start Single Service */}
        <div className="single-service">
          <i className="icofont icofont-bars"></i>
          <h4>
            <p className="service-link">FINANCIAL STRATEGIES</p> {/* Button instead of <a> */}
          </h4>
          <p>• Financial Needs Analysis</p>
          <p>• Financial Goal Setting</p>
          <p>• Strategies to Pursue Your Goals</p>
        </div>
        {/* End Single Service */}
      </div>
      <div className="col-lg-4 col-md-6 col-12">
        {/* Start Single Service */}
        <div className="single-service">
          <i className="icofont icofont-shield"></i>
          <h4>
            <p className="service-link">PROPER PROTECTION</p> {/* Button instead of <a> */}
          </h4>
          <p>Protection assets and family against loss of income and sickness</p>
        </div>
        {/* End Single Service */}
      </div>
      <div className="col-lg-4 col-md-6 col-12">
        {/* Start Single Service */}
        <div className="single-service">
          <i className="icofont icofont-dollar-plus"></i>
          <h4>
            <p className="service-link">EMERGENCY FUND</p> {/* Button instead of <a> */}
          </h4>
          <p>Prepare for unexpected expenses by saving 3 to 6 months of income</p>
        </div>
        {/* End Single Service */}
      </div>
      <div className="col-lg-4 col-md-6 col-12">
        {/* Start Single Service */}
        <div className="single-service">
          <i className="icofont icofont-chart-pie"></i>
          <h4>
            <p className="service-link">DEBT MANAGEMENT</p> {/* Button instead of <a> */}
          </h4>
          <p>Develop a plan to become debt-free while building wealth</p>
        </div>
        {/* End Single Service */}
      </div>
      <div className="col-lg-4 col-md-6 col-12">
        {/* Start Single Service */}
        <div className="single-service">
          <i className="icofont icofont-chart-histogram-alt"></i>
          <h4>
            <p className="service-link">BUILD WEALTH</p> {/* Button instead of <a> */}
          </h4>
          <p>Save to outpace inflation and reduce taxation</p>
        </div>
        {/* End Single Service */}
      </div>
      <div className="col-lg-4 col-md-6 col-12">
        {/* Start Single Service */}
        <div className="single-service">
          <i className="icofont icofont-bank"></i>
          <h4>
            <p className="service-link">PRESERVE WEALTH</p> {/* Button instead of <a> */}
          </h4>
          <p>Build a family legacy for generations to come</p>
        </div>
        {/* End Single Service */}
      </div>
    </div>
  </div>
</section>

      <div className="clients overlay">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 col-md-12 col-12">
              <div className="owl-carousel clients-slider">
                <div className="single-clients">
                  <img src="img/client1.png" alt="#" />
                </div>
                <div className="single-clients">
                  <img src="img/client2.png" alt="#" />
                </div>
                <div className="single-clients">
                  <img src="img/client3.png" alt="#" />
                </div>
                <div className="single-clients">
                  <img src="img/client4.png" alt="#" />
                </div>
                <div className="single-clients">
                  <img src="img/client5.png" alt="#" />
                </div>
                <div className="single-clients">
                  <img src="img/client6.png" alt="#" />
                </div>
                
                <div className="single-clients">
                  <img src="img/client9.png" alt="#" />
                </div>
                <div className="single-clients">
                  <img src="img/client11.png" alt="#" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* End Schedule Area */}

      {/* Start Testimonials */}
     
      <section className="testimonials">
  <div className="container">
    <div className="row">
      <div className="col-lg-12">
        <div className="section">
          <h2 style={{ textAlign: "center" }}>What Our Clients Say!</h2>
        </div>
        <div id="unique-testimonials" className="owl-carousel">
          {/* TESTIMONIAL 1 */}
          <div className="item">
            <div className="shadow-effect">
              <p>"Charlotte is very nice and amazing to work with. Knowledgeable in financial service and planning. Caring and easy to work with ☑️👍🏼👍🏼"</p>
            </div>
            <div className="testimonial-name">
              Angelo C.
              <p style={{ color: "whitesmoke" }}>CEO & Founder iGoWebSolution.Com</p>
            </div>
          </div>
          {/* END OF TESTIMONIAL 1 */}
          
          {/* TESTIMONIAL 3 */}
          <div className="item">
            <div className="shadow-effect">
              <p>"It's been great knowing Charlotte for many years, she is very professional and has high standards. She has personally helped and given me great advice for my business and personal finances. I highly recommend her. She has great leadership and financial skills."</p>
            </div>
            <div className="testimonial-name">
              Jose
              <p style={{ color: "whitesmoke" }}>Organic Services Inc.</p>
            </div>
          </div>
          {/* END OF TESTIMONIAL 3 */}
          {/* TESTIMONIAL 2 */}
          <div className="item">
            <div className="shadow-effect">
              <p>"Charlotte Enriquez is an amazing senior broker with many years of experience. She'll help your business succeed through her company's financial platform system that'll train you and your staff on how to improve your marketing, sales, and personable skills! She can also help you with estate planning."</p>
            </div>
            <div className="testimonial-name">
              Wassim Yassine
              <p style={{ color: "whitesmoke" }}>A-Z Driving School - Owner</p>
            </div>
          </div>
          {/* END OF TESTIMONIAL 2 */}
        </div>
      </div>
    </div>
  </div>
</section>

      {/* End Testimonials */}
    </div>
  );
};

export default Home;
